import gql from "graphql-tag";

export const LOGIN = gql`
  mutation ($id: String!, $password: String!) {
    login(userId: $id, password: $password) {
      Token
      Admin {
        Permission
      }
    }
  }
`;

export const GETCHECKAUTH = gql`
  mutation ($token: String!) {
    getCheckAuth(token: $token) {
      _id
      ID
      Email
      Permission
      Cashier_ID
    }
  }
`;

export const CREATEEMAILCODE = gql`
  mutation createEmailCode($Email: String) {
    createEmailCode(Email: $Email) {
      Admin {
        Email
      }
      Code
    }
  }
`;

export const CHECKEMAILCODE = gql`
  query checkEmailCode($Email: String, $Code: String) {
    checkEmailCode(Email: $Email, Code: $Code) {
      Admin {
        ID
        _id
      }
      Code
    }
  }
`;

export const CREATEADMIN = gql`
  mutation createAdmin(
    $ID: String!
    $Email: String!
    $PW: String!
    $Permission: Int!
    $Cashier_ID: String
  ) {
    createAdmin(
      ID: $ID
      Email: $Email
      PW: $PW
      Permission: $Permission
      Cashier_ID: $Cashier_ID
    ) {
      ResultCount
    }
  }
`;

export const UPDATEADMIN = gql`
  mutation updateAdmin(
    $_id: Int!
    $Email: String
    $PW: String
    $Permission: Int
    $Cashier_ID: String
  ) {
    updateAdmin(
      _id: $_id
      Email: $Email
      PW: $PW
      Permission: $Permission
      Cashier_ID: $Cashier_ID
    ) {
      ResultCount
    }
  }
`;

export const UPDATEADMINNEW = gql`
  mutation updateNewPasswd(
    $_id: Int!
    $ID: String!
    $Email: String!
    $NewPasswd: String!
  ) {
    updateNewPasswd(_id: $_id, ID: $ID, Email: $Email, NewPasswd: $NewPasswd) {
      ResultCount
    }
  }
`;

export const DELETEADMIN = gql`
  mutation deleteAdmin($_id: Int!) {
    deleteAdmin(_id: $_id) {
      ResultCount
    }
  }
`;

export const CHECKTEMPLATEANDUPDATE = gql`
  mutation {
    checkTemplateAndUpdate
  }
`;

export const UPDATECUSTOMER = gql`
  mutation updateCustomer(
    $CustNum: String!
    $First_Name: String
    $Last_Name: String
    $Company: String
    $Address_1: String
    $Address_2: String
    $City: String
    $Zip_Code: String
    $Phone_1: String
    $Phone_2: String
  ) {
    updateCustomer(
      CustNum: $CustNum
      First_Name: $First_Name
      Last_Name: $Last_Name
      Company: $Company
      Address_1: $Address_1
      Address_2: $Address_2
      City: $City
      Zip_Code: $Zip_Code
      Phone_1: $Phone_1
      Phone_2: $Phone_2
    ) {
      ResultCount
    }
  }
`;
